// src/App.jsx
import React from 'react';
import { PlayerProvider } from './contexts/PlayerContext';
import { Route, Routes, BrowserRouter as Router, useLocation } from 'react-router-dom';
import GoogleAnalytics from './components/GoogleAnalytics';
import AppLayout from './components/layout/AppLayout';
import HomePage from './features/home/HomePage';
import ContactPage from './features/contact/ContactPage';
import './App.css';

// Import the logo asset
import logoFile from './assets/cards/logo192.png';

// Add ScrollToTop component to scroll to top on route changes
function ScrollToTop() {
  const { pathname } = useLocation();
  
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [pathname]);
  
  return null;
}

console.log('App Environment:', {
  NODE_ENV: process.env.NODE_ENV,
  SANITY_PROJECT_ID: process.env.REACT_APP_SANITY_PROJECT_ID,
  SANITY_DATASET: process.env.REACT_APP_SANITY_DATASET,
  DEV_STREAM_URL: process.env.REACT_APP_DEV_STREAM_URL
});

function App() {
  return (
    <Router>
      <GoogleAnalytics />
      <ScrollToTop />
      <PlayerProvider>
        <Routes>
          <Route path="/" element={<AppLayout logoSrc={logoFile} />}>
            <Route index element={<HomePage />} />
            <Route path="contact" element={<ContactPage />} />
            {/* Redirect all other routes to home */}
            <Route path="*" element={<HomePage />} />
          </Route>
        </Routes>
      </PlayerProvider>
    </Router>
  );
}

export default App;